import React, { FC, memo } from "react";

import { SocBindCallbackScreen } from "../";

export const BindYandexRedirect: FC = memo(() => <SocBindCallbackScreen network="yandex" />);
